import React, { memo } from 'react';

import { Flex } from '@/lib/v2/components/Layout/Stack';
import { Text } from '@/lib/v2/components/Text';

export type StatsProps = {
  quantity: number;
  state: string;
};

export const StatsCards = memo(
  ({ stats, children }: { stats: Array<StatsProps>; children?: React.ReactNode }) => {
    return (
      <Flex column>
        <Flex withGap gapSize="medium">
          {stats.map((stat) => (
            <Flex
              key={stat.state}
              column
              withGap
              className="w-1/4 rounded-t-md bg-[#004DBC] px-8 py-4"
              gapSize="small"
              itemAlignment="start"
            >
              {stat.quantity !== undefined ? (
                <Text as="h1" color="white" variant="title-1">
                  {stat.quantity}
                </Text>
              ) : (
                <Text as="h1" color="white" variant="title-1">
                  ---
                </Text>
              )}
              <Text color="white" variant="sub-headline">
                {stat.state}
              </Text>
            </Flex>
          ))}
        </Flex>
        <>{children}</>
      </Flex>
    );
  }
);
